import React from 'react';
import '../CRM.css';

const STAGES = ['New', 'Contacted', 'Interested', 'Qualified', 'Requirement', 'Quotation', 'Negotiation', 'Won', 'Lost'];

const STAGE_COLORS = {
  New: '#6366F1', Contacted: '#0EA5E9', Interested: '#10B981',
  Qualified: '#F59E0B', Requirement: '#8B5CF6', Quotation: '#06B6D4',
  Negotiation: '#EF4444', Won: '#16A34A', Lost: '#94A3B8',
};

export const PipelineBoard = ({ opportunities = [], onStageChange, onOpenCard }) => {
  const [dragOver, setDragOver] = React.useState(null);
  const [dragged, setDragged] = React.useState(null);

  const byStage = (stage) => opportunities.filter((o) => (o.stage || 'New') === stage);

  const handleDrop = (stage) => {
    if (dragged && onStageChange) onStageChange(dragged, stage);
    setDragged(null);
    setDragOver(null);
  };

  return (
    <div className="crm-kanban">
      {STAGES.map((stage) => {
        const items = byStage(stage);
        const total = items.reduce((s, o) => s + Number(o.expectedValue || 0), 0);
        return (
          <div className="crm-kanban-col" key={stage}
            onDragOver={(e) => { e.preventDefault(); setDragOver(stage); }}
            onDragLeave={() => setDragOver(null)}
            onDrop={() => handleDrop(stage)}
          >
            <div className="crm-kanban-col-head">
              <span className="crm-kanban-col-title" style={{ color: STAGE_COLORS[stage] }}>{stage}</span>
              <span className="crm-kanban-col-count">{items.length}</span>
            </div>
            <div style={{ padding: '6px 16px', fontSize: '0.74rem', color: 'var(--ink-soft)', fontWeight: 600 }}>
              ₹{total.toLocaleString('en-IN')}
            </div>
            <div className="crm-kanban-col-body">
              {items.map((opp) => (
                <div
                  key={opp.id}
                  className={`crm-kanban-card ${dragged === opp.id ? 'dragging' : ''}`}
                  draggable
                  onDragStart={() => setDragged(opp.id)}
                  onDragEnd={() => { setDragged(null); setDragOver(null); }}
                  onClick={() => onOpenCard?.(opp)}
                >
                  <div className="crm-kanban-card-id">{opp.opportunityId}</div>
                  <div className="crm-kanban-card-name">{opp.customerName}</div>
                  <div className="crm-kanban-card-company">{opp.company}</div>
                  <div className="crm-kanban-card-value">₹{Number(opp.expectedValue || 0).toLocaleString('en-IN')}</div>
                  <div className="crm-kanban-card-meta">
                    <span>{opp.salesperson || '—'}</span>
                    <span>{opp.probability || 0}%</span>
                  </div>
                  <div className="crm-kanban-card-meta">
                    <span>Close: {opp.expectedCloseDate || '—'}</span>
                  </div>
                </div>
              ))}
              {items.length === 0 && dragOver === stage && (
                <div className="crm-kanban-drop over">Drop here</div>
              )}
              {items.length === 0 && dragOver !== stage && (
                <div className="crm-kanban-drop">No opportunities</div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PipelineBoard;
